(() => {
  const isTouch =
    window.matchMedia?.("(hover: none)")?.matches ||
    window.matchMedia?.("(pointer: coarse)")?.matches;

  if (!isTouch) return;

  const PRODUCT_LINK_SEL = 'a[href*="/products/"]';
  const HERO_EXCLUDE_SEL = 'a[class*="ai-hero-media-link-"], a[class*="ai-hero-plus-four-hero-link-"]';
  const HOVER_IMG_SEL = 'img[class*="image-hover"]';
  const ARM_WINDOW_MS = 2500;

  const armed = new Map(); // href -> timestamp
  const now = () => Date.now();

  const ignored = (t) =>
    !!t.closest(
      'button, [role="button"], input, select, textarea, label, .swatch, .swatches, [data-swatch], .quick-add, [data-quick-add]'
    );

  const purge = () => {
    const t = now();
    for (const [href, ts] of armed.entries()) {
      if (t - ts > ARM_WINDOW_MS) armed.delete(href);
    }
  };

  // Find a “tile” container that contains BOTH the link and the hover image
  const findTile = (link) => {
    let el = link;
    for (let i = 0; i < 14 && el && el !== document.body; i++) {
      if (el.querySelector?.(HOVER_IMG_SEL)) return el;
      el = el.parentElement;
    }
    return null;
  };

  // Only swap if there is a REAL second image
  const swapToHover = (tile) => {
    const hover = tile.querySelector(HOVER_IMG_SEL);
    if (!hover) return false;

    const primary =
      hover.parentElement?.querySelector?.("img:not([class*='image-hover'])") ||
      tile.querySelector("img:not([class*='image-hover'])");

    if (!primary) return false;

    const primarySrc = primary.currentSrc || primary.getAttribute("src") || "";
    const hoverSrc = hover.currentSrc || hover.getAttribute("src") || "";

    if (!hoverSrc) return false;

    const stripQuery = (u) => String(u).split("?")[0];
    if (stripQuery(primarySrc) && stripQuery(primarySrc) === stripQuery(hoverSrc)) {
      return false;
    }

    primary.style.opacity = "0";
    primary.style.visibility = "hidden";

    hover.style.opacity = "1";
    hover.style.visibility = "visible";

    return true;
  };

  const clearAll = () => {
    document.querySelectorAll(HOVER_IMG_SEL).forEach((hover) => {
      const tile = hover.closest("a, div, li, article, section") || document;
      const primary =
        hover.parentElement?.querySelector?.("img:not([class*='image-hover'])") ||
        tile.querySelector?.("img:not([class*='image-hover'])");

      if (primary) {
        primary.style.opacity = "";
        primary.style.visibility = "";
      }
      hover.style.opacity = "";
      hover.style.visibility = "";
    });

    armed.clear();
  };

  // Tap 1: intercept on touchstart
  document.addEventListener(
    "touchstart",
    (e) => {
      if (ignored(e.target)) return;

      purge();

      const link = e.target.closest(PRODUCT_LINK_SEL);
      if (!link) return;

      // Exclude hero links from double-tap behavior
      if (link.matches(HERO_EXCLUDE_SEL)) return;

      const tile = findTile(link);
      if (!tile) return;

      const href = link.href;
      const ts = armed.get(href);

      if (!ts) {
        const didSwap = swapToHover(tile);
        if (!didSwap) return;

        e.preventDefault();
        e.stopImmediatePropagation?.();
        e.stopPropagation();

        armed.clear();
        armed.set(href, now());
      }
    },
    { capture: true, passive: false }
  );

  // Tap 2: force navigation
  document.addEventListener(
    "click",
    (e) => {
      if (ignored(e.target)) return;

      purge();

      const link = e.target.closest(PRODUCT_LINK_SEL);
      if (!link) return;

      // Exclude hero links from double-tap behavior
      if (link.matches(HERO_EXCLUDE_SEL)) return;

      const href = link.href;
      const ts = armed.get(href);

      if (ts && now() - ts <= ARM_WINDOW_MS) {
        e.preventDefault();
        e.stopImmediatePropagation?.();
        e.stopPropagation();

        window.location.href = href;
      }
    },
    true
  );

  // Clear when tapping elsewhere / scrolling
  document.addEventListener(
    "touchstart",
    (e) => {
      if (!e.target.closest(PRODUCT_LINK_SEL)) clearAll();
    },
    { capture: true, passive: true }
  );

  let st;
  window.addEventListener(
    "scroll",
    () => {
      clearTimeout(st);
      st = setTimeout(clearAll, 150);
    },
    { passive: true }
  );
})();